import { useState, useEffect } from 'react'
import { api } from '../lib/api'
import toast from 'react-hot-toast'

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Clash+Display:wght@400;500;600;700&family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500&display=swap');
.cg *{box-sizing:border-box;margin:0;padding:0;}
.cg{font-family:'DM Sans',sans-serif;background:#0a0a0f;color:#e8e8f0;}
.cg-mono{font-family:'JetBrains Mono','Courier New',monospace;}
.cg-clash{font-family:'Clash Display',sans-serif;}
.cg-orb{position:absolute;border-radius:50%;filter:blur(120px);opacity:0.08;pointer-events:none;}
.cg-tab{flex-shrink:0;padding:11px 13px;font-size:10px;text-transform:uppercase;letter-spacing:1px;color:#6b6b80;border:none;background:transparent;cursor:pointer;border-bottom:2px solid transparent;transition:all .2s;white-space:nowrap;font-family:'JetBrains Mono',monospace;display:flex;align-items:center;gap:5px;}
.cg-tab:hover{color:#e8e8f0;}.cg-tab.active{color:#7c5cfc;border-bottom-color:#7c5cfc;}.cg-tab.done{color:#5cfcb4;border-bottom-color:#5cfcb4;}.cg-tab.locked{opacity:.3;cursor:not-allowed;}
.cg-card{background:#111118;border:1px solid #252530;border-radius:16px;padding:24px;margin-bottom:16px;}
.cg-lbl{display:block;font-size:10px;font-family:'JetBrains Mono',monospace;color:#6b6b80;text-transform:uppercase;letter-spacing:1px;margin-bottom:5px;}
.cg-inp{width:100%;background:#18181f;border:1px solid #252530;border-radius:8px;padding:10px 12px;color:#e8e8f0;font-family:'DM Sans',sans-serif;font-size:13px;outline:none;transition:border-color .2s;}
.cg-inp:focus{border-color:#7c5cfc;}.cg-inp::placeholder{color:#6b6b80;}
.cg-btn{display:inline-flex;align-items:center;gap:7px;padding:10px 20px;border-radius:8px;font-family:'DM Sans',sans-serif;font-size:13px;font-weight:600;cursor:pointer;border:none;transition:all .2s;}
.cg-btn.primary{background:#7c5cfc;color:#fff;}.cg-btn.primary:hover{background:#5a52e0;transform:translateY(-1px);}.cg-btn.primary:disabled{opacity:.4;cursor:not-allowed;transform:none;}
.cg-btn.outline{background:transparent;border:1px solid #252530;color:#e8e8f0;}.cg-btn.outline:hover{border-color:#7c5cfc;color:#7c5cfc;}
.cg-btn.success{background:#5cfcb4;color:#000;}.cg-btn.success:hover{background:#35d468;transform:translateY(-1px);}
.cg-btn.sm{padding:6px 12px;font-size:11px;}
.cg-btn.danger{background:transparent;border:1px solid rgba(252,92,125,.3);color:#fc5c7d;}.cg-btn.danger:hover{background:rgba(252,92,125,.1);}
.cg-choice{background:#18181f;border:1px solid #252530;border-radius:10px;padding:12px 15px;cursor:pointer;transition:all .2s;display:flex;align-items:flex-start;gap:12px;margin-bottom:8px;position:relative;}
.cg-choice:hover{border-color:#7c5cfc;background:rgba(108,99,255,.07);}.cg-choice.sel{border-color:#7c5cfc;background:rgba(108,99,255,.12);}.cg-choice.multi{border-color:#5cfcb4;background:rgba(67,233,123,.08);}
.cg-num{font-family:'JetBrains Mono',monospace;font-size:10px;color:#6b6b80;background:#252530;border-radius:4px;padding:2px 6px;flex-shrink:0;margin-top:2px;}
.cg-choice.sel .cg-num{background:#7c5cfc;color:#fff;}.cg-choice.multi .cg-num{background:#5cfcb4;color:#000;}
.cg-regen-btn{position:absolute;top:8px;right:8px;background:rgba(124,92,252,0.15);border:1px solid rgba(124,92,252,0.3);color:#a080ff;border-radius:6px;padding:3px 7px;font-size:11px;cursor:pointer;line-height:1;transition:all .15s;}
.cg-regen-btn:hover{background:rgba(124,92,252,0.3);}
.cg-regen-btn:disabled{opacity:.4;cursor:not-allowed;}
.cg-para{background:#18181f;border-left:3px solid #7c5cfc;border-radius:0 8px 8px 0;padding:12px 14px;margin-bottom:10px;position:relative;padding-right:60px;}
.cg-out-lbl{font-family:'Clash Display',sans-serif;font-size:12px;letter-spacing:2px;color:#fcc85c;margin-bottom:7px;padding-bottom:5px;border-bottom:1px solid #252530;}
.cg-out-txt{background:#18181f;border:1px solid #252530;border-radius:8px;padding:12px;font-family:'JetBrains Mono',monospace;font-size:11px;line-height:1.7;white-space:pre-wrap;color:#e8e8f0;max-height:200px;overflow-y:auto;}
.cg-spinner{width:30px;height:30px;border:3px solid #252530;border-top-color:#7c5cfc;border-radius:50%;animation:cg-spin .7s linear infinite;}
.cg-spinner-sm{width:14px;height:14px;border:2px solid #252530;border-top-color:#7c5cfc;border-radius:50%;animation:cg-spin .7s linear infinite;display:inline-block;}
@keyframes cg-spin{to{transform:rotate(360deg);}}
.cg-review{background:#18181f;border:1px solid #252530;border-radius:10px;padding:12px;margin-bottom:8px;position:relative;padding-right:60px;}
.cg-faq-item{margin-bottom:12px;padding:10px 12px;background:#18181f;border:1px solid #252530;border-radius:8px;position:relative;padding-right:60px;}
.cg-faq-q{font-weight:600;font-size:12px;color:#7c5cfc;margin-bottom:3px;}.cg-faq-a{font-size:11px;color:#6b6b80;line-height:1.6;}
.cg-lang-chip{padding:6px 12px;border-radius:8px;cursor:pointer;border:1px solid #252530;background:#18181f;color:#6b6b80;font-size:11px;font-weight:600;transition:all .15s;display:inline-flex;align-items:center;gap:5px;margin:3px;}
.cg-lang-chip.sel{border-color:#fc5c7d;background:rgba(252,92,125,.15);color:#fc5c7d;}
.cg-instr-panel{position:absolute;top:0;right:0;bottom:0;width:360px;background:#111118;border-left:1px solid #252530;display:flex;flex-direction:column;z-index:50;transform:translateX(100%);transition:transform .25s ease;box-shadow:-20px 0 60px rgba(0,0,0,.6);}
.cg-instr-panel.open{transform:translateX(0);}
.cg-instr-body{flex:1;overflow-y:auto;padding:20px;scrollbar-width:thin;scrollbar-color:#252530 transparent;}
.cg-instr-field{margin-bottom:14px;}.cg-instr-field label{display:block;font-size:11px;font-weight:600;color:#e8e8f0;margin-bottom:5px;}
.cg-instr-field textarea{width:100%;background:#18181f;border:1px solid #252530;border-radius:8px;color:#e8e8f0;font-family:'DM Sans',sans-serif;font-size:12px;line-height:1.5;padding:9px 11px;resize:vertical;min-height:72px;outline:none;transition:border-color .2s;}
.cg-instr-field textarea:focus{border-color:#7c5cfc;}
.cg-section-lbl{font-family:'JetBrains Mono',monospace;font-size:9px;text-transform:uppercase;letter-spacing:.1em;color:#6b6b80;margin:18px 0 10px;padding-top:14px;border-top:1px solid #252530;}
.cg-section-lbl:first-child{margin-top:0;padding-top:0;border-top:none;}
@keyframes cg-fadein{from{opacity:0;transform:translateY(6px);}to{opacity:1;transform:none;}}
.cg-step{animation:cg-fadein .25s ease;}
.cg-row{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:12px;}
`

const LANGUAGES = ['Swedish','Dutch','Norwegian','German','French','Danish','Finnish','Spanish','Italian','Portuguese','Polish','English']

const DEFAULT_INSTR = {
  brand: `Generate creative, memorable, and trademarkable brand names. Avoid generic words. Make them unique and easy to pronounce. Consider the target market and product category. Always add trademark symbol (TM) in the brand name.`,
  title: `Title Structure (MANDATORY):
Product Name | Address a Strong Pain Point with percentage change with timeframe

You must:
- Clearly explain what the product does
- Address a major pain point
- Include a timeframe (check competitor timeframes first; if none exist, create a believable one)

Examples:
OregaCleanse™ | Reduce Bloating by up to 89% and feel lighter within 84 hours
OxiPure™ | Clear your airways by 95% in just 48 hours
Flexion™ | Move up to 89% more smoothly in just 2 days

Keep titles: Concise, Emotionally charged, Believable.`,

  benefits: `Max 45 Characters Each (STRICT — count every character):
USP 1: Mirrors the main title promise
USP 2: Emotional relief or confidence boost
USP 3: Position as a non-invasive alternative (example: No surgery, no medications or procedures)
USP 4: Doctor approval or expert recommendation (example: Recommended by ENT specialists)
USP 5: Always → "No results? Money Back!"`,

  paragraph: `Write persuasive, SEO-optimized product description paragraphs. Use power words. Write in second person (you/your).

Headline structure (MANDATORY):
Headline 1 — Core Problem + Promise (same as first benefit)
Headline 2 — Risk Awareness / Why Action Matters
Headline 3 — Reduce problem with solution
Headline 4 — Doctor assurance
Headline 5 — Final Outcome + happy life

Paragraph Formula (MANDATORY):
1. Start with frustration or insecurity
2. Explain why the problem hurts emotionally or physically
3. Introduce the product as the safe, easy solution
4. Explain benefits or mechanism in simple language
5. End with relief, confidence, or life improvement
Minimum 5 sentences, maximum 6 sentences per paragraph.`,

  reviews: `Write 9 short, conversational reviews (do not use product name with trademark in reviews).
- Minimum 5 sentences per review
- Customer names must reflect the language/culture of the target market
- From different perspectives
- Each review highlights one clear benefit
- Write naturally like real customers, not marketers`,

  faqs: `Create 5 persuasive FAQs covering:
1. How it works
2. When results appear
3. Safety / ingredients
4. How to use
5. Refund policy
Tone: reassuring, confident, simple.`,

  translate: `Translate the content naturally, as if it were originally written in the target language. Do not do a literal translation. Maintain the marketing tone and persuasive language. Adapt idioms and cultural references appropriately. Keep [bracket headlines] exactly as-is structure.`,

  adcopy: `You are an elite Facebook ad copywriter for eCommerce. Your copy must convert AND pass Meta's automated ad review on the first attempt. Meta's AI classifiers scan at word, phrase and sentence level — a rejected ad earns zero. Treat compliance as a craft constraint, like a word limit, not as a reason to write bland copy.

HARD RULES — breaking these gets ads rejected and accounts restricted:

1. PERSONAL ATTRIBUTES (Meta's #1 rejection cause)
Never assert or imply you know anything personal about the reader: health condition, body, age, finances, or group membership. The trap is "you". Indirect framing is now flagged equally.
BAD: "Struggling with swollen legs?" / "Do you suffer from joint pain?" / "For people managing diabetes" / "Those dealing with bloating"
GOOD: "Swollen legs are far more common than most people realise." / "Lymph drainage used to mean a 90 euro clinic visit."
FIX PATTERN: never "you have X" — instead state X as a general truth, or describe a third person who had it.

2. HEALTH CLAIMS — structure/function only
Never use treat, cure, prevent, heal, fix, eliminate, reverse or remedy with any condition or disease name.
BAD: "Treats water retention" / "Eliminates cellulite"
GOOD: "Formulated to support the body's natural drainage" / "Designed to support healthy circulation"

3. NO GUARANTEES, NO SPECIFIC OUTCOMES OR TIMELINES
BAD: "80% less swelling in 3 days" / "Guaranteed results" / "Results in one week"
GOOD: "Many people notice a difference within a few weeks."

4. NO TRANSFORMATION / BEFORE-AFTER FRAMING
Do not describe or imply a before-to-after journey or visible physical change.
BAD: "From swollen to slim" / "You won't believe the difference"

5. NO NEGATIVE SELF-PERCEPTION
Meta explicitly bans copy that creates shame to sell health products.
BAD: "Embarrassed by your legs?" / "Stop hiding your smile"
GOOD: focus on what people gain, never on what is wrong with them.

6. NO SHOCK, GORE OR SENSATIONALISM
BAD: amputation, blood, extreme suffering, clickbait horror.

7. NO EXPERT/AUTHORITY ENDORSEMENT OF OUTCOMES
BAD: "Doctors recommend..." / "Proctologists discovered..." / "I am a doctor and I tell every patient..."
GOOD: a named individual sharing their own experience, with no credential used to endorse a health outcome.

WHAT STILL WORKS — this is where the conversion comes from:
- Story: a specific named person, a specific moment, real texture and detail
- Curiosity gaps and pattern interrupts
- Economic arguments (clinic sessions cost 90 euro a month)
- Specificity about the product, ingredients and mechanism (not about outcomes)
- Social proof as volume (over 20,000 orders), never as a promised result
- Honest urgency (a real deadline, a real stock level) — never fake countdowns

COPY REQUIREMENTS:
- Primary text: under 125 words
- Headline: under 40 CHARACTERS (hard character limit, not a word count)
- Description: under 30 words
- Write like a human, not a marketer. Short punchy sentences.
- Benefits over features. Emojis only where natural.
- One scroll-stopping first line. One emotional trigger. One clear CTA.

Generate 3 versions, each a completely different angle:
A) Story / Relatable Moment
B) Social Proof / Tribe
C) Curiosity / Pattern Interrupt

For each version, self-audit: list any line that could plausibly trip Meta review, and why. If a version is fully clean, return an empty array. Be honest in this audit — it is more useful than a perfect score.`,
}

// Bump when DEFAULT_INSTR changes — forces everyone onto the new instructions
// instead of a stale localStorage copy from the Backend Instructions panel.
const INSTR_VERSION = 'v2-meta-2026'
function loadInstr() {
  try {
    if (localStorage.getItem('cg_instr_version') !== INSTR_VERSION) {
      localStorage.removeItem('cg_instructions_cache')
      localStorage.setItem('cg_instr_version', INSTR_VERSION)
      return DEFAULT_INSTR
    }
    return { ...DEFAULT_INSTR, ...JSON.parse(localStorage.getItem('cg_instructions_cache') || '{}') }
  }
  catch { return DEFAULT_INSTR }
}

// GPT = ChatGPT for all content generation
async function callGPT(system, user) {
  const token = localStorage.getItem('adops_token')
  const r = await fetch('/api/content/proxy-gpt', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ system, user })
  })
  const d = await r.json()
  if (d.error) throw new Error(d.error)
  return d.text
}

// Claude = for translation and ad copy only
async function callClaude(system, user, maxTokens = 3000) {
  const token = localStorage.getItem('adops_token')
  const r = await fetch('/api/content/proxy-claude', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ system, user, max_tokens: maxTokens })
  })
  const d = await r.json()
  if (d.error) throw new Error(d.error)
  return d.text
}

function pj(t) {
  try { return JSON.parse(t.replace(/```json|```/g, '').trim()) }
  catch { const m = t.match(/(\[[\s\S]*\]|\{[\s\S]*\})/); if (m) return JSON.parse(m[1]); throw new Error('JSON parse failed') }
}

const S = { accent:'#7c5cfc',accent2:'#fc5c7d',accent3:'#5cfcb4',gold:'#fcc85c',muted:'#6b6b80',border:'#252530',surface:'#111118',surface2:'#18181f',text:'#e8e8f0' }

export default function ContentGenerator({ product, onClose }) {
  const _persistKey = `cg_draft_${product?.id || product?.product_id || 'x'}`
  const _saved = (() => { try { return JSON.parse(localStorage.getItem(_persistKey) || 'null') } catch { return null } })()
  const _g = (k, d) => (_saved && _saved[k] !== undefined ? _saved[k] : d)
  const [minimized, setMinimized] = useState(false)
  const [step, setStep] = useState(_g('step',1))
  const [maxStep, setMaxStep] = useState(_g('maxStep',1))
  const [instrOpen, setInstrOpen] = useState(false)
  const [instr, setInstr] = useState(loadInstr)
  const [instrSaving, setInstrSaving] = useState(false)
  const [instrSaved, setInstrSaved] = useState(false)

  // Step 1
  const [compName, setCompName] = useState(_g('compName', product?.product_name || ''))
  const [compUrl, setCompUrl] = useState(_g('compUrl', product?.competitor_product_url || ''))
  const [audience, setAudience] = useState(_g('audience',''))
  const [usp, setUsp] = useState(_g('usp',''))
  const [compExtracted, setCompExtracted] = useState(_g('compExtracted',''))
  const [fetchingUrl, setFetchingUrl] = useState(false)
  const [fetchError, setFetchError] = useState('')

  // Generated content
  const [brandOptions, setBrandOptions] = useState(_g('brandOptions',[]))
  const [selectedBrand, setSelectedBrand] = useState(_g('selectedBrand',null))

  // Convert (TM)/(R) to ™/® when displaying, and back when sending to GPT
  function toDisplay(text) {
    if (!text) return text
    return text.replace(/\(TM\)/gi, '™').replace(/\(R\)/gi, '®')
  }
  function toGPT(text) {
    if (!text) return text
    return text.replace(/™/g, '(TM)').replace(/®/g, '(R)')
  }
  const [titleOptions, setTitleOptions] = useState(_g('titleOptions',[]))
  const [selectedTitle, setSelectedTitle] = useState(_g('selectedTitle',null))
  const [benefitOptions, setBenefitOptions] = useState(_g('benefitOptions',[]))
  const [selectedBenefits, setSelectedBenefits] = useState(_g('selectedBenefits',[]))
  const [paragraphs, setParagraphs] = useState(_g('paragraphs',[]))
  const [reviews, setReviews] = useState(_g('reviews',[]))
  const [faqs, setFaqs] = useState(_g('faqs',[]))

  // Regen loading states
  const [regenLoading, setRegenLoading] = useState({}) // {ben_0: true, para_0: true, etc}

  // Preview / translate
  const [previewLang, setPreviewLang] = useState('English')
  const [translatingTo, setTranslatingTo] = useState('')
  const [translating, setTranslating] = useState(false)
  const [translated, setTranslated] = useState(_g('translated',{}))
  const [funnelProducts, setFunnelProducts] = useState([])
  const [selectedFunnelProduct, setSelectedFunnelProduct] = useState(null)
  const [funnelMarket, setFunnelMarket] = useState('')
  const [funnelProductMarkets, setFunnelProductMarkets] = useState([])
  const [importingFunnel, setImportingFunnel] = useState(false)
  const [funnelImported, setFunnelImported] = useState({})
  const [funnelMarkets, setFunnelMarkets] = useState([]) // markets for selected funnel product
  const [selectedFunnelMarket, setSelectedFunnelMarket] = useState('')

  // Ad copy
  const [adObjective, setAdObjective] = useState('conversions')
  const [adTone, setAdTone] = useState('urgent')
  const [adCta, setAdCta] = useState('Shop Now')
  const [adVersionsEN, setAdVersionsEN] = useState(_g('adVersionsEN',[]))
  const [selectedAdVersion, setSelectedAdVersion] = useState(0)
  const [adLang, setAdLang] = useState('English')
  const [translatedAds, setTranslatedAds] = useState(_g('translatedAds',{}))
  const [translatingAds, setTranslatingAds] = useState(false)
  const [translatingAdsTo, setTranslatingAdsTo] = useState('')
  const [adProducts, setAdProducts] = useState([])
  const [selectedAdProduct, setSelectedAdProduct] = useState(null)
  const [adProductMarkets, setAdProductMarkets] = useState([])
  const [importingAd, setImportingAd] = useState(false)
  const [adImported, setAdImported] = useState({})

  useEffect(() => {
    try {
      localStorage.setItem(_persistKey, JSON.stringify({
        step, maxStep, compName, compUrl, audience, usp, compExtracted,
        brandOptions, selectedBrand, titleOptions, selectedTitle,
        benefitOptions, selectedBenefits, paragraphs, reviews, faqs,
        adVersionsEN, translated, translatedAds,
      }))
    } catch {}
  }, [step, maxStep, compName, compUrl, audience, usp, compExtracted, brandOptions, selectedBrand, titleOptions, selectedTitle, benefitOptions, selectedBenefits, paragraphs, reviews, faqs, adVersionsEN, translated, translatedAds])

  function startOver() {
    if (!window.confirm('Clear all progress for this product and start fresh?')) return
    try { localStorage.removeItem(_persistKey) } catch {}
    window.location.reload()
  }
  const [adMarkets, setAdMarkets] = useState([]) // markets for selected ad product
  const [selectedAdMarket, setSelectedAdMarket] = useState('')

  const [loading, setLoading] = useState(false)
  const [loadingMsg, setLoadingMsg] = useState('')

  const STEPS = [
    {n:1,l:'Input'},{n:2,l:'Brands'},{n:3,l:'Title'},{n:4,l:'Benefits'},
    {n:5,l:'Paragraphs'},{n:6,l:'Reviews'},{n:7,l:'FAQs'},
    {n:8,l:'Preview'},{n:9,l:'Ad Copy'},{n:10,l:'Finish'},
  ]

  useEffect(() => {
    api.getSettings().then(s => {
      if (s.instructions) {
        const merged = { ...DEFAULT_INSTR, ...s.instructions }
        setInstr(merged)
        localStorage.setItem('cg_instructions_cache', JSON.stringify(merged))
      }
    }).catch(() => {})
    api.getProducts().then(ps => { setFunnelProducts(ps); setAdProducts(ps) }).catch(() => {})
  }, [])

  function goTo(n) { if (n <= maxStep) setStep(n) }
  function unlock(n) { setMaxStep(m => Math.max(m, n)); setStep(n) }
  function updateInstr(key, val) { setInstr(prev => ({ ...prev, [key]: val })); setInstrSaved(false) }

  async function saveInstrToDB() {
    setInstrSaving(true)
    try {
      await api.updateSetting('instructions', instr)
      localStorage.setItem('cg_instructions_cache', JSON.stringify(instr))
      setInstrSaved(true); toast.success('Instructions saved!')
    } catch (err) { toast.error('Failed: ' + err.message) }
    setInstrSaving(false)
  }

  const ctx = () => `Product: ${product?.product_name}
Competitor: ${compName}
Competitor URL: ${compUrl}
${compExtracted ? `Competitor Page Content:\n${compExtracted.substring(0, 2000)}` : ''}
Audience: ${audience}
Offer/USP: ${usp || 'Not provided — infer a strong unique selling point from the product details above.'}
Price: €${product?.selling_price_eur}`.trim()

  // ── Fetch competitor URL ──
  async function fetchCompetitorUrl() {
    if (!compUrl.trim()) { toast.error('Enter a competitor URL first'); return }
    setFetchingUrl(true)
    setFetchError('')
    setCompExtracted('')
    try {
      const token = localStorage.getItem('adops_token')
      const r = await fetch('/api/content/fetch-url', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ url: compUrl })
      })
      const d = await r.json()
      if (d.success) {
        setCompExtracted(d.extracted)
        toast.success('Page content extracted successfully!')
      } else {
        setFetchError(d.error)
      }
    } catch (err) { setFetchError('Failed to fetch: ' + err.message) }
    setFetchingUrl(false)
  }

  // ── STEP 1→2: Brand names via GPT ──
  async function runStep1() {
    setLoading(true); setLoadingMsg('Generating brand names via ChatGPT...')
    try {
      const res = pj(await callGPT(
        `${instr.brand} IMPORTANT: Never use ™ or ® directly — write (TM) or (R). Respond with valid JSON only.`,
        `${ctx()}\n\nRespond with JSON only:\n[{"name":"BrandName(TM)","rationale":"Why it works"},...] — generate 5 options`
      ))
      // Convert (TM)/(R) back to ™/® for display
      const opts = (Array.isArray(res) ? res : res.options || []).map(b => ({
        ...b,
        name: b.name.replace(/\(TM\)/gi, '™').replace(/\(R\)/gi, '®')
      }))
      setBrandOptions(opts)
      unlock(2)
    } catch (err) { toast.error(err.message) }
    setLoading(false)
  }

  // ── STEP 2→3: Titles via GPT ──
  async function runStep2() {
    setLoading(true); setLoadingMsg('Generating product titles via ChatGPT...')
    try {
      const res = pj(await callGPT(
        `${instr.title} IMPORTANT: Brand name is: ${selectedBrand.replace('™','(TM)').replace('®','(R)')} — always include at start with (TM). Never use ™ or ® directly. Respond with valid JSON only.`,
        `Brand: "${toGPT(selectedBrand)}"\n${ctx()}\n\nJSON: [{"title":"Full Title","hook":"Why it converts"},...] — generate 5 options`
      ))
      const titleOpts = (Array.isArray(res) ? res : res.options || []).map(t => ({
        ...t,
        title: t.title.replace(/\(TM\)/gi, '™').replace(/\(R\)/gi, '®')
      }))
      setTitleOptions(titleOpts)
      unlock(3)
    } catch (err) { toast.error(err.message) }
    setLoading(false)
  }

  // ── STEP 3→4: Benefits via GPT ──
  async function runStep3() {
    setLoading(true); setLoadingMsg('Generating benefits via ChatGPT...')
    try {
      const res = pj(await callGPT(
        `${instr.benefits} STRICT RULE: Every single benefit must be 45 characters or fewer. Count the characters. Respond with valid JSON only.`,
        `Brand: "${toGPT(selectedBrand)}"\nProduct: "${selectedTitle}"\n${ctx()}\n\nJSON array of strings (MAX 45 chars each):\n["Benefit 1","Benefit 2",...] — generate 5 benefits`
      ))
      setBenefitOptions(Array.isArray(res) ? res : [])
      setSelectedBenefits([])
      unlock(4)
    } catch (err) { toast.error(err.message) }
    setLoading(false)
  }

  // ── Regen single benefit ──
  async function regenBenefit(idx) {
    setRegenLoading(p => ({ ...p, [`ben_${idx}`]: true }))
    const original = benefitOptions[idx]
    const otherSelected = selectedBenefits.filter(b => b !== original)
    try {
      const res = pj(await callGPT(
        `${instr.benefits} STRICT RULE: Result must be 45 characters or fewer. Respond with valid JSON only.`,
        `Brand: "${toGPT(selectedBrand)}"\nProduct: "${selectedTitle}"\nAudience: ${audience}\nOriginal benefit: "${original}"\nRewrite this benefit differently — same purpose and intent, different wording or angle. Do not generate a random new benefit.\nJSON: ["Rewritten benefit"]`
      ))
      const newBenefit = Array.isArray(res) ? res[0] : res
      setBenefitOptions(prev => { const n = [...prev]; n[idx] = newBenefit; return n })
      // Update selection if it was selected
      if (selectedBenefits.includes(original)) {
        setSelectedBenefits(prev => prev.map(b => b === original ? newBenefit : b))
      }
    } catch (err) { toast.error('Regen failed: ' + err.message) }
    setRegenLoading(p => ({ ...p, [`ben_${idx}`]: false }))
  }

  // ── STEP 4→5: Paragraphs via GPT (one per selected benefit) ──
  async function runStep4() {
    if (!selectedBenefits.length) { toast.error('Select at least 1 benefit'); return }
    setLoading(true); setLoadingMsg('Writing paragraphs via ChatGPT...')
    try {
      const res = pj(await callGPT(
        `${instr.paragraph} Respond with valid JSON only.`,
        `Brand: "${toGPT(selectedBrand)}"\nProduct: "${selectedTitle}"\nAudience: ${audience}\n\nBenefits (one paragraph per benefit):\n${selectedBenefits.map((b,i) => `${i+1}. ${b}`).join('\n')}\n\nRespond with JSON only:\n[{"headline":"[Headline]","body":"Body text"},...]`
      ))
      setParagraphs(Array.isArray(res) ? res : res.paragraphs || [])
      unlock(5)
    } catch (err) { toast.error(err.message) }
    setLoading(false)
  }

  // ── Regen single paragraph ──
  async function regenParagraph(idx) {
    setRegenLoading(p => ({ ...p, [`para_${idx}`]: true }))
    const benefit = selectedBenefits[idx] || ''
    try {
      const res = pj(await callGPT(
        `${instr.paragraph} Respond with valid JSON only.`,
        `Brand: "${toGPT(selectedBrand)}"\nProduct: "${selectedTitle}"\nAudience: ${audience}\nBenefit: "${benefit}"\n\nWrite 1 paragraph. JSON:\n{"headline":"[Headline]","body":"Body text"}`
      ))
      setParagraphs(prev => { const n = [...prev]; n[idx] = res; return n })
    } catch (err) { toast.error('Regen failed: ' + err.message) }
    setRegenLoading(p => ({ ...p, [`para_${idx}`]: false }))
  }

  // ── STEP 5→6: Reviews via GPT ──
  async function runStep5() {
    setLoading(true); setLoadingMsg('Generating 9 reviews via ChatGPT...')
    try {
      const res = pj(await callGPT(
        `${instr.reviews} Respond with valid JSON only.`,
        `Brand: "${toGPT(selectedBrand)}"\nProduct: "${selectedTitle}"\nCompetitor: "${compName}"\nAudience: ${audience}\n\nRespond with JSON only:\n[{"name":"First Last","review":"Review text"},...] — generate 10 reviews`
      ))
      setReviews(Array.isArray(res) ? res : res.reviews || [])
      unlock(6)
    } catch (err) { toast.error(err.message) }
    setLoading(false)
  }

  // ── Regen single review ──
  async function regenReview(idx) {
    setRegenLoading(p => ({ ...p, [`rev_${idx}`]: true }))
    const existing = reviews.map(r => r.name).filter((_, i) => i !== idx)
    try {
      const res = pj(await callGPT(
        `${instr.reviews} Respond with valid JSON only.`,
        `Brand: "${toGPT(selectedBrand)}"\nProduct: "${selectedTitle}"\nAudience: ${audience}\nExisting reviewer names (do not repeat): ${existing.join(', ')}\n\nGenerate exactly 1 new review. JSON:\n[{"name":"First Last","review":"Review text"}]`
      ))
      const newReview = Array.isArray(res) ? res[0] : res
      setReviews(prev => { const n = [...prev]; n[idx] = newReview; return n })
    } catch (err) { toast.error('Regen failed: ' + err.message) }
    setRegenLoading(p => ({ ...p, [`rev_${idx}`]: false }))
  }

  // ── STEP 6→7: FAQs via GPT ──
  async function runStep6() {
    setLoading(true); setLoadingMsg('Generating FAQs via ChatGPT...')
    try {
      const res = pj(await callGPT(
        `${instr.faqs} Respond with valid JSON only.`,
        `Brand: "${toGPT(selectedBrand)}"\nProduct: "${selectedTitle}"\nCompetitor: "${compName}"\nAudience: ${audience}\n\nRespond with JSON only:\n[{"question":"Q?","answer":"30-60 word answer"},...] — generate 5 FAQs`
      ))
      setFaqs(Array.isArray(res) ? res : res.faqs || [])
      unlock(7)
      unlock(8)
    } catch (err) { toast.error(err.message) }
    setLoading(false)
  }

  // ── Regen single FAQ ──
  async function regenFaq(idx) {
    setRegenLoading(p => ({ ...p, [`faq_${idx}`]: true }))
    const existing = faqs.map(f => f.question).filter((_, i) => i !== idx)
    try {
      const res = pj(await callGPT(
        `${instr.faqs} Respond with valid JSON only.`,
        `Brand: "${toGPT(selectedBrand)}"\nProduct: "${selectedTitle}"\nExisting questions (do not repeat): ${existing.join(' | ')}\n\nGenerate exactly 1 new FAQ. JSON:\n[{"question":"Q?","answer":"30-60 word answer"}]`
      ))
      const newFaq = Array.isArray(res) ? res[0] : res
      setFaqs(prev => { const n = [...prev]; n[idx] = newFaq; return n })
    } catch (err) { toast.error('Regen failed: ' + err.message) }
    setRegenLoading(p => ({ ...p, [`faq_${idx}`]: false }))
  }

  // ── STEP 8: Translate via Claude (3 parallel calls like BrandForge) ──
  async function translateContent(lang) {
    if (lang === 'English') { setPreviewLang('English'); return }
    if (translated[lang]) { setPreviewLang(lang); return }
    setTranslatingTo(lang)
    setTranslating(true)
    const sys = `${instr.translate} Translate to ${lang}. Return only translated text, preserving all XML tags and [bracket] headlines exactly as-is structure.`
    const c1 = `<BRAND>${selectedBrand}</BRAND>\n<TITLE>${selectedTitle}</TITLE>\n<BENEFITS>\n${selectedBenefits.map((b,i) => `${i+1}. ${b}`).join('\n')}\n</BENEFITS>\n<PARAGRAPHS>\n${paragraphs.map(p => `[${p.headline}]\n${p.body}`).join('\n\n')}\n</PARAGRAPHS>`
    const c2 = `<REVIEWS>\n${reviews.map((rv,i) => `<REVIEW>\n<NAME>${rv.name}</NAME>\n<RBODY>${rv.review}</RBODY>\n</REVIEW>`).join('\n\n')}\n</REVIEWS>`
    const c3 = `<FAQS>\n${faqs.map((f,i) => `<FAQ>\n<Q>${f.question}</Q>\n<A>${f.answer}</A>\n</FAQ>`).join('\n\n')}\n</FAQS>`
    try {
      const [t1, t2, t3] = await Promise.all([
        callClaude(sys, `Translate to ${lang}:\n\n${c1}`, 4000),
        callClaude(sys, `Translate to ${lang}:\n\n${c2}`, 4000),
        callClaude(sys, `Translate to ${lang}:\n\n${c3}`, 3000),
      ])
      // Parse translated content
      const parsed = parseTranslated(t1, t2, t3, lang)
      setTranslated(prev => ({ ...prev, [lang]: parsed }))
      setPreviewLang(lang)
    } catch (err) { toast.error('Translation failed: ' + err.message) }
    setTranslating(false)
    setTranslatingTo('')
  }

  function parseTranslated(t1, t2, t3, lang) {
    // Parse t1 — brand, title, benefits, paragraphs
    let brand = selectedBrand, title = selectedTitle
    const bens = [], paras = []
    let mode = '', cur = null
    t1.split('\n').forEach(l => {
      const lt = l.trim()
      if (lt.includes('<BRAND>') && lt.includes('</BRAND>')) { brand = lt.replace(/<\/?BRAND>/g, '').trim() }
      else if (lt.includes('<TITLE>') && lt.includes('</TITLE>')) { title = lt.replace(/<\/?TITLE>/g, '').trim() }
      else if (lt === '<BENEFITS>') { mode = 'ben' }
      else if (lt === '</BENEFITS>') { mode = '' }
      else if (lt === '<PARAGRAPHS>') { mode = 'para' }
      else if (lt === '</PARAGRAPHS>') { if (cur) { paras.push(cur); cur = null } mode = '' }
      else if (mode === 'ben' && lt && !lt.startsWith('<')) { bens.push(lt.replace(/^\d+\.\s*/, '')) }
      else if (mode === 'para') {
        const hm = lt.match(/^\[(.+)\]$/)
        if (hm) { if (cur) paras.push(cur); cur = { headline: hm[1], body: '' } }
        else if (cur && lt) cur.body += (cur.body ? ' ' : '') + lt
      }
    })
    if (cur) paras.push(cur)

    // Parse t2 — reviews
    const revs = []
    const reviewBlocks = t2.split(/<REVIEW>/).slice(1)
    reviewBlocks.forEach(block => {
      const nameM = block.match(/<NAME>([\s\S]*?)<\/NAME>/)
      const bodyM = block.match(/<RBODY>([\s\S]*?)<\/RBODY>/)
      if (nameM && bodyM) revs.push({ name: nameM[1].trim(), review: bodyM[1].trim() })
    })

    // Parse t3 — faqs
    const faqsParsed = []
    const faqBlocks = t3.split(/<FAQ>/).slice(1)
    faqBlocks.forEach(block => {
      const qM = block.match(/<Q>([\s\S]*?)<\/Q>/)
      const aM = block.match(/<A>([\s\S]*?)<\/A>/)
      if (qM && aM) faqsParsed.push({ question: qM[1].trim(), answer: aM[1].trim() })
    })

    return {
      brand: brand || selectedBrand,
      title: title || selectedTitle,
      benefits: bens.length ? bens : selectedBenefits,
      paragraphs: paras.length ? paras : paragraphs,
      reviews: revs.length ? revs : reviews,
      faqs: faqsParsed.length ? faqsParsed : faqs,
    }
  }

  function getPreview() {
    if (previewLang === 'English') return { brand: selectedBrand, title: selectedTitle, benefits: selectedBenefits, paragraphs, reviews, faqs }
    return translated[previewLang] || null
  }

  async function loadProductMarkets(productId, setter) {
    if (!productId) { setter([]); return }
    try {
      const token = localStorage.getItem('adops_token')
      const r = await fetch(`/api/funnel/product/${productId}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      const rows = await r.json()
      setter(Array.isArray(rows) ? rows.map(r => r.market) : [])
    } catch { setter([]) }
  }

  async function loadFunnelMarkets(productId) {
    if (!productId) { setFunnelMarkets([]); setSelectedFunnelMarket(''); return }
    try {
      const token = localStorage.getItem('adops_token')
      const r = await fetch(`/api/content/markets/${productId}`, { headers: { Authorization: `Bearer ${token}` } })
      const markets = await r.json()
      setFunnelMarkets(markets)
      setSelectedFunnelMarket(markets[0] || '')
    } catch { setFunnelMarkets([]) }
  }

  async function loadAdMarkets(productId) {
    if (!productId) { setAdMarkets([]); setSelectedAdMarket(''); return }
    try {
      const token = localStorage.getItem('adops_token')
      const r = await fetch(`/api/content/markets/${productId}`, { headers: { Authorization: `Bearer ${token}` } })
      const markets = await r.json()
      setAdMarkets(markets)
      setSelectedAdMarket(markets[0] || '')
    } catch { setAdMarkets([]) }
  }

  async function importToFunnel() {
    if (!selectedFunnelProduct) { toast.error('Select a product'); return }
    if (!selectedFunnelMarket) { toast.error('Select a market first'); return }
    const preview = getPreview()
    if (!preview) { toast.error('No content to import'); return }
    setImportingFunnel(true)
    try {
      const token = localStorage.getItem('adops_token')
      await fetch('/api/content/import-funnel-direct', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({
          product_id: selectedFunnelProduct,
          mode: 'market',
          market: selectedFunnelMarket,
          language: previewLang,
          brand_name: preview.brand,
          title: preview.title,
          benefits: Array.isArray(preview.benefits) ? preview.benefits.join('\n') : preview.benefits,
          paragraphs: Array.isArray(preview.paragraphs) ? preview.paragraphs.map(p => `[${p.headline}]\n${p.body}`).join('\n\n') : preview.paragraphs,
          reviews: Array.isArray(preview.reviews) ? preview.reviews.map(r => `${r.name}\n★★★★★\n${r.review}`).join('\n\n') : preview.reviews,
          faqs: Array.isArray(preview.faqs) ? preview.faqs.map((f,i) => `Q${i+1}: ${f.question}\nA: ${f.answer}`).join('\n\n') : preview.faqs,
        })
      })
      setFunnelImported(prev => ({ ...prev, [`${selectedFunnelProduct}_${previewLang}`]: true }))
      toast.success(`✓ ${previewLang} content imported to Product ${selectedFunnelProduct}!`)
    } catch (err) { toast.error(err.message) }
    setImportingFunnel(false)
  }

  // ── STEP 9: Ad copy via Claude ──
  async function generateAdCopy() {
    setLoading(true); setLoadingMsg('Crafting 3 Facebook ad versions via Claude...')
    try {
      const res = pj(await callClaude(
        `${instr.adcopy} Return valid JSON only.`,
        `Product:"${selectedTitle}" by ${selectedBrand}\nObjective:${adObjective}\nCTA:${adCta}\nTone:${adTone}\nBenefits:${selectedBenefits.join(', ')}\nOffer:${usp || 'infer a strong USP from the product, title and benefits above'}\nCompetitor:${compName}\n\nApply every HARD RULE from your instructions. Primary text under 125 words. Headline under 40 characters.\n\nJSON:\n[{"version":"A","approach":"Story / Relatable Moment","primaryText":"...","headline":"...","description":"...","score":87,"scoreBreakdown":{"relevance":90,"clarity":85,"cta_strength":88,"compliance":95,"emotional_hook":80},"whyItWorks":"...","bestFor":"...","complianceNotes":["any line that could trip Meta review + why, or empty array if clean"]},...]`,
        8000
      ))
      const versions = Array.isArray(res) ? res : []
      versions.sort((a, b) => b.score - a.score)
      if (versions[0]) versions[0].isWinner = true
      setAdVersionsEN(versions)
      setSelectedAdVersion(0)
    } catch (err) { toast.error(err.message) }
    setLoading(false)
  }

  // ── Translate ad copy via Claude ──
  async function translateAds(lang) {
    if (lang === 'English') { setAdLang('English'); return }
    if (translatedAds[lang]) { setAdLang(lang); return }
    setTranslatingAdsTo(lang)
    setTranslatingAds(true)
    try {
      const adContent = adVersionsEN.map(v =>
        `Version ${v.version} (${v.approach}):\nPrimary Text: ${v.primaryText}\nHeadline: ${v.headline}\nDescription: ${v.description || ''}`
      ).join('\n\n---\n\n')
      // Use XML-tag format (not JSON) so quotes inside copy can never break parsing
      const raw = await callClaude(
        `${instr.translate} Translate Facebook ad copy to ${lang}. Keep the version labels and structure. Return ONLY the translated content wrapped in the exact XML tags shown — no JSON, no extra text.`,
        `Translate these Facebook ad versions to ${lang}. For EACH version output this block exactly:\n<AD>\n<VER>version letter</VER>\n<APPROACH>approach</APPROACH>\n<PRIMARY>translated primary text</PRIMARY>\n<HEADLINE>translated headline</HEADLINE>\n<WHY>why it works</WHY>\n</AD>\n\nSource versions:\n\n${adContent}`,
        4000
      )
      // Parse XML blocks
      const enVersions = adVersionsEN
      const versions = raw.split(/<AD>/).slice(1).map((block, i) => {
        const g = (tag) => { const m = block.match(new RegExp('<'+tag+'>([\\s\\S]*?)<\\/'+tag+'>')); return m ? m[1].trim() : '' }
        return {
          version: g('VER') || (enVersions[i] && enVersions[i].version) || String.fromCharCode(65+i),
          approach: g('APPROACH') || (enVersions[i] && enVersions[i].approach) || '',
          primaryText: g('PRIMARY'),
          headline: g('HEADLINE'),
          description: '',
          score: (enVersions[i] && enVersions[i].score) || 85,
          whyItWorks: g('WHY') || ''
        }
      }).filter(v => v.primaryText || v.headline)
      if (versions[0]) versions[0].isWinner = true
      setTranslatedAds(prev => ({ ...prev, [lang]: versions }))
      setAdLang(lang)
      setSelectedAdVersion(0)
    } catch (err) { toast.error('Translation failed: ' + err.message) }
    setTranslatingAds(false)
    setTranslatingAdsTo('')
  }

  function getCurrentAds() {
    if (adLang === 'English') return adVersionsEN
    return translatedAds[adLang] || []
  }

  async function importAdCopy() {
    if (!selectedAdProduct) { toast.error('Select a product'); return }
    setImportingAd(true)
    const ads = getCurrentAds()
    const chosen = ads[selectedAdVersion] || ads[0]
    if (!chosen) { toast.error('No ad copy to import'); setImportingAd(false); return }
    try {
      const token = localStorage.getItem('adops_token')
      await fetch('/api/content/import-adcopy-direct', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ product_id: selectedAdProduct, market: selectedAdMarket, language: adLang, ai_copy_primary: chosen.primaryText, ai_copy_headline: chosen.headline })
      })
      setAdImported(prev => ({ ...prev, [`${selectedAdProduct}_${adLang}`]: true }))
      toast.success(`✓ Ad copy (Version ${chosen.version}) imported to Product ${selectedAdProduct} in ${adLang}!`)
    } catch (err) { toast.error(err.message) }
    setImportingAd(false)
  }

  // Helper render functions (NOT React components - avoids recreation on each render)
  function renderLoading(msg) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14, padding: 50 }}>
        <div className="cg-spinner" />
        <div className="cg-mono" style={{ fontSize: 11, color: S.muted }}>{msg || loadingMsg}</div>
      </div>
    )
  }

  function renderRegenBtn(id, onClick) {
    return (
      <button className="cg-regen-btn" disabled={!!regenLoading[id]} onClick={e => { e.stopPropagation(); onClick() }}>
        {regenLoading[id] ? <span className="cg-spinner-sm" /> : '↺'}
      </button>
    )
  }

  const preview = getPreview()
  const currentAds = getCurrentAds()
  const progress = Math.round((step / STEPS.length) * 100)

  return (
    <>
      <style>{CSS}</style>
      {minimized && (
        <div onClick={() => setMinimized(false)} style={{ position: 'fixed', bottom: 20, right: 20, zIndex: 200, background: '#1a1430', border: '1px solid rgba(124,92,252,.4)', borderRadius: 12, padding: '12px 18px', cursor: 'pointer', boxShadow: '0 8px 30px rgba(0,0,0,.5)', display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#7C5CFC' }} />
          <span style={{ color: '#fff', fontSize: 13, fontWeight: 600 }}>Content Creator — {product?.product_name?.substring(0,25)}</span>
          <span style={{ color: '#a48cfd', fontSize: 11 }}>▲ resume</span>
        </div>
      )}
      <div style={{ position: 'fixed', inset: 0, zIndex: 200, display: minimized ? 'none' : 'flex' }}>
        <div style={{ flex: 1, background: 'rgba(0,0,0,0.75)' }} onClick={onClose} />
        <div className="cg" style={{ width: 800, display: 'flex', flexDirection: 'column', position: 'relative', overflow: 'hidden', boxShadow: '-20px 0 80px rgba(0,0,0,.7)' }}>
          <div className="cg-orb" style={{ width: 500, height: 500, background: S.accent, top: -200, left: -200 }} />
          <div className="cg-orb" style={{ width: 400, height: 400, background: S.accent2, bottom: -150, right: -150 }} />

          {/* Header */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 20px', height: 58, borderBottom: `1px solid ${S.border}`, background: 'rgba(10,10,15,0.9)', flexShrink: 0, zIndex: 10, position: 'relative' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <div style={{ width: 8, height: 8, borderRadius: '50%', background: S.accent, boxShadow: `0 0 12px ${S.accent}` }} />
              <span className="cg-clash" style={{ fontSize: 17, fontWeight: 700, color: '#fff', letterSpacing: -0.5 }}>Content Creator</span>
              <span style={{ fontSize: 10, fontWeight: 600, color: '#a48cfd', background: 'rgba(124,92,252,.1)', border: '1px solid rgba(124,92,252,.25)', borderRadius: 100, padding: '3px 10px' }}>
                {product?.product_name?.substring(0, 35)}{(product?.product_name?.length || 0) > 35 ? '...' : ''}
              </span>
            </div>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <span className="cg-mono" style={{ fontSize: 9, color: S.muted, border: `1px solid ${S.border}`, borderRadius: 6, padding: '3px 7px' }}>
                GPT-4o + Claude
              </span>
              <button onClick={() => setInstrOpen(o => !o)} style={{ background: instrOpen ? 'rgba(124,92,252,.2)' : S.surface2, border: `1px solid ${instrOpen ? S.accent : S.border}`, color: instrOpen ? '#a080ff' : S.muted, borderRadius: 8, padding: '6px 12px', cursor: 'pointer', fontSize: 11, fontWeight: 600 }}>
                ⚙ Backend Instructions
              </button>
              <button onClick={startOver} style={{ background: S.surface2, border: `1px solid ${S.border}`, color: S.muted, borderRadius: 8, padding: '6px 10px', cursor: 'pointer', fontSize: 11, fontWeight: 600 }}>↺ Start Over</button>
              <button onClick={() => setMinimized(true)} title="Minimize" style={{ background: S.surface2, border: `1px solid ${S.border}`, color: S.muted, borderRadius: 8, width: 30, height: 30, cursor: 'pointer', fontSize: 16, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>—</button>
              <button onClick={onClose} style={{ background: S.surface2, border: `1px solid ${S.border}`, color: S.muted, borderRadius: 8, width: 30, height: 30, cursor: 'pointer', fontSize: 16, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>×</button>
            </div>
          </div>

          {/* Tabs */}
          <div style={{ display: 'flex', overflowX: 'auto', background: S.surface, borderBottom: `1px solid ${S.border}`, flexShrink: 0, scrollbarWidth: 'none', zIndex: 9, position: 'relative' }}>
            {STEPS.map(s => (
              <button key={s.n} className={`cg-tab ${s.n === step ? 'active' : s.n < step ? 'done' : 'locked'}`} onClick={() => goTo(s.n)}>
                <div style={{ width: 5, height: 5, borderRadius: '50%', background: s.n < step ? S.accent3 : s.n === step ? S.accent : S.border }} />
                {s.l}
              </button>
            ))}
          </div>

          {/* Progress */}
          <div style={{ height: 2, background: S.border, flexShrink: 0 }}>
            <div style={{ width: `${progress}%`, height: '100%', background: `linear-gradient(90deg,${S.accent},${S.accent2})`, transition: 'width .4s' }} />
          </div>

          {/* Content */}
          <div style={{ flex: 1, overflow: 'hidden', display: 'flex', position: 'relative' }}>
            <div style={{ flex: 1, overflowY: 'auto', padding: 20, position: 'relative', zIndex: 1 }}>

              {/* STEP 1 */}
              {step === 1 && (
                <div className="cg-step">
                  <div className="cg-card">
                    <div className="cg-clash" style={{ fontSize: 17, letterSpacing: 2, color: S.accent, marginBottom: 4 }}>01 — Competitor Analysis</div>
                    <div style={{ fontSize: 12, color: S.muted, marginBottom: 18 }}>All content generated in English first. Translate in Preview step via Claude.</div>
                    <div className="cg-row">
                      <div><label className="cg-lbl">Competitor Product Name</label><input className="cg-inp" value={compName} onChange={e => setCompName(e.target.value)} /></div>
                      <div><label className="cg-lbl">Target Audience</label><input className="cg-inp" value={audience} onChange={e => setAudience(e.target.value)} placeholder="e.g. Women 30-50, health conscious" /></div>
                    </div>
                    <div style={{ marginBottom: 12 }}>
                      <label className="cg-lbl">Competitor Product URL</label>
                      <div style={{ display: 'flex', gap: 8 }}>
                        <input className="cg-inp" value={compUrl} onChange={e => { setCompUrl(e.target.value); setCompExtracted(''); setFetchError('') }} style={{ flex: 1 }} />
                        <button className="cg-btn outline sm" onClick={fetchCompetitorUrl} disabled={fetchingUrl || !compUrl.trim()} style={{ flexShrink: 0, whiteSpace: 'nowrap' }}>
                          {fetchingUrl ? <><span className="cg-spinner-sm" /> Fetching...</> : '🔍 Fetch Page'}
                        </button>
                      </div>
                      {fetchError && (
                        <div style={{ marginTop: 8, padding: '8px 12px', background: 'rgba(252,92,125,.08)', border: '1px solid rgba(252,92,125,.25)', borderRadius: 8, fontSize: 11, color: '#fc5c7d' }}>
                          ⚠ {fetchError}
                        </div>
                      )}
                      {compExtracted && (
                        <div style={{ marginTop: 8 }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
                            <span style={{ fontSize: 10, color: S.accent3, fontFamily: 'monospace', textTransform: 'uppercase', letterSpacing: 1 }}>✓ Page content extracted ({compExtracted.length} chars)</span>
                            <button onClick={() => setCompExtracted('')} style={{ fontSize: 10, color: S.muted, background: 'none', border: 'none', cursor: 'pointer' }}>✕ Clear</button>
                          </div>
                          <textarea className="cg-inp" value={compExtracted} onChange={e => setCompExtracted(e.target.value)} rows={5} style={{ fontSize: 11, resize: 'vertical', fontFamily: 'monospace' }} />
                        </div>
                      )}
                    </div>
                    <div><label className="cg-lbl">Unique Selling Points / Offer (optional)</label><textarea className="cg-inp" rows={2} value={usp} onChange={e => setUsp(e.target.value)} style={{ resize: 'vertical', minHeight: 60 }} /></div>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <button className="cg-btn primary" onClick={runStep1} disabled={loading}>
                      {loading ? <><div className="cg-spinner" style={{ width: 14, height: 14, borderWidth: 2 }} /> {loadingMsg}</> : 'Generate Brand Names →'}
                    </button>
                  </div>
                </div>
              )}

              {/* STEP 2 — Brands */}
              {step === 2 && (
                <div className="cg-step">
                  <div className="cg-card">
                    <div className="cg-clash" style={{ fontSize: 17, letterSpacing: 2, color: S.accent, marginBottom: 4 }}>02 — Choose Brand Name</div>
                    <div style={{ fontSize: 12, color: S.muted, marginBottom: 14 }}>Select 1 brand name. <span style={{ color: S.accent, fontSize: 11 }}>via ChatGPT</span></div>
                    {loading ? renderLoading() : brandOptions.map((b, i) => (
                      <div key={i} className={`cg-choice ${selectedBrand === b.name ? 'sel' : ''}`} onClick={() => setSelectedBrand(toDisplay(b.name))}>
                        <div className="cg-num">{String.fromCharCode(65 + i)}</div>
                        <div><div style={{ fontWeight: 600, fontSize: 14 }}>{b.name}</div><div style={{ fontSize: 12, color: S.muted, marginTop: 2 }}>{b.rationale}</div></div>
                      </div>
                    ))}
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <button className="cg-btn outline sm" onClick={runStep1}>↺ Regenerate All</button>
                    <button className="cg-btn primary" onClick={runStep2} disabled={!selectedBrand || loading}>Next: Product Title →</button>
                  </div>
                </div>
              )}

              {/* STEP 3 — Titles */}
              {step === 3 && (
                <div className="cg-step">
                  <div className="cg-card">
                    <div className="cg-clash" style={{ fontSize: 17, letterSpacing: 2, color: S.accent, marginBottom: 4 }}>03 — Choose Product Title</div>
                    <div style={{ fontSize: 12, color: S.muted, marginBottom: 14 }}>Select 1 title for <span style={{ color: S.accent }}>{selectedBrand}</span>. <span style={{ color: S.accent, fontSize: 11 }}>via ChatGPT</span></div>
                    {loading ? renderLoading() : titleOptions.map((t, i) => (
                      <div key={i} className={`cg-choice ${selectedTitle === t.title ? 'sel' : ''}`} onClick={() => { let t2 = toDisplay(t.title); if(selectedBrand){const plain=selectedBrand.replace('™','').replace('®',''); t2=t2.replace(new RegExp(plain+'(?![™®])','g'),selectedBrand);} setSelectedTitle(t2) }}>
                        <div className="cg-num">{String.fromCharCode(65 + i)}</div>
                        <div><div style={{ fontWeight: 600, fontSize: 14 }}>{t.title}</div><div style={{ fontSize: 12, color: S.muted, marginTop: 2 }}>{t.hook}</div></div>
                      </div>
                    ))}
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <button className="cg-btn outline sm" onClick={runStep2}>↺ Regenerate All</button>
                    <button className="cg-btn primary" onClick={runStep3} disabled={!selectedTitle || loading}>Next: Benefits →</button>
                  </div>
                </div>
              )}

              {/* STEP 4 — Benefits */}
              {step === 4 && (
                <div className="cg-step">
                  <div className="cg-card">
                    <div className="cg-clash" style={{ fontSize: 17, letterSpacing: 2, color: S.accent, marginBottom: 4 }}>04 — Select Benefits</div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                      <span className="cg-mono" style={{ fontSize: 11, color: S.gold }}>{selectedBenefits.length} selected</span>
                      <span style={{ fontSize: 10, color: S.muted }}>via ChatGPT — ↺ to regenerate individual benefit</span>
                    </div>
                    {loading ? renderLoading() : benefitOptions.map((b, i) => {
                      const sel = selectedBenefits.includes(b)
                      return (
                        <div key={i} className={`cg-choice ${sel ? 'multi' : ''}`} onClick={() => setSelectedBenefits(prev => prev.includes(b) ? prev.filter(x => x !== b) : [...prev, b])} style={{ paddingRight: 44 }}>
                          <div className="cg-num" style={{ background: sel ? S.accent3 : S.border, color: sel ? '#000' : S.muted }}>{i + 1}</div>
                          <div style={{ fontSize: 13, flex: 1 }}>{b}</div>
                          {renderRegenBtn(`ben_${i}`, () => regenBenefit(i))}
                        </div>
                      )
                    })}
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <button className="cg-btn outline sm" onClick={runStep3}>↺ Regenerate All</button>
                    <button className="cg-btn primary" onClick={runStep4} disabled={!selectedBenefits.length || loading}>
                      {loading ? loadingMsg : 'Next: Paragraphs →'}
                    </button>
                  </div>
                </div>
              )}

              {/* STEP 5 — Paragraphs */}
              {step === 5 && (
                <div className="cg-step">
                  <div className="cg-card">
                    <div className="cg-clash" style={{ fontSize: 17, letterSpacing: 2, color: S.accent, marginBottom: 4 }}>05 — Paragraphs (English)</div>
                    <div style={{ fontSize: 12, color: S.muted, marginBottom: 14 }}>One paragraph per benefit. <span style={{ color: S.accent, fontSize: 11 }}>via ChatGPT — ↺ to regenerate individual paragraph</span></div>
                    {loading ? renderLoading() : paragraphs.map((p, i) => (
                      <div key={i} className="cg-para">
                        <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 4, color: S.text }}>{p.headline}</div>
                        <div style={{ fontSize: 12, color: S.muted, lineHeight: 1.7 }}>{p.body}</div>
                        {renderRegenBtn(`para_${i}`, () => regenParagraph(i))}
                      </div>
                    ))}
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <button className="cg-btn outline sm" onClick={runStep4}>↺ Regenerate All</button>
                    <button className="cg-btn primary" onClick={runStep5} disabled={loading}>{loading ? loadingMsg : 'Next: Reviews →'}</button>
                  </div>
                </div>
              )}

              {/* STEP 6 — Reviews */}
              {step === 6 && (
                <div className="cg-step">
                  <div className="cg-card">
                    <div className="cg-clash" style={{ fontSize: 17, letterSpacing: 2, color: S.accent, marginBottom: 4 }}>06 — Reviews (English)</div>
                    <div style={{ fontSize: 12, color: S.muted, marginBottom: 14 }}>9 authentic reviews. <span style={{ color: S.accent, fontSize: 11 }}>via ChatGPT — ↺ to regenerate individual review</span></div>
                    {loading ? renderLoading() : reviews.map((r, i) => (
                      <div key={i} className="cg-review">
                        <div style={{ fontWeight: 600, fontSize: 13 }}>{r.name}</div>
                        <div style={{ color: S.gold, fontSize: 12, margin: '3px 0' }}>★★★★★</div>
                        <div style={{ fontSize: 12, color: S.muted, lineHeight: 1.6 }}>{r.review}</div>
                        {renderRegenBtn(`rev_${i}`, () => regenReview(i))}
                      </div>
                    ))}
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <button className="cg-btn outline sm" onClick={runStep5}>↺ Regenerate All</button>
                    <button className="cg-btn primary" onClick={runStep6} disabled={loading}>{loading ? loadingMsg : 'Next: FAQs →'}</button>
                  </div>
                </div>
              )}

              {/* STEP 7 — FAQs */}
              {step === 7 && (
                <div className="cg-step">
                  <div className="cg-card">
                    <div className="cg-clash" style={{ fontSize: 17, letterSpacing: 2, color: S.accent, marginBottom: 4 }}>07 — FAQs (English)</div>
                    <div style={{ fontSize: 12, color: S.muted, marginBottom: 14 }}>5 persuasive FAQs. <span style={{ color: S.accent, fontSize: 11 }}>via ChatGPT — ↺ to regenerate individual FAQ</span></div>
                    {loading ? renderLoading() : faqs.map((f, i) => (
                      <div key={i} className="cg-faq-item">
                        <div className="cg-faq-q">Q{i + 1}: {f.question}</div>
                        <div className="cg-faq-a">A: {f.answer}</div>
                        {renderRegenBtn(`faq_${i}`, () => regenFaq(i))}
                      </div>
                    ))}
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <button className="cg-btn outline sm" onClick={runStep6}>↺ Regenerate All</button>
                    <button className="cg-btn primary" onClick={() => unlock(8)} disabled={loading}>Preview & Translate →</button>
                  </div>
                </div>
              )}

              {/* STEP 8 — Preview, Translate, Import */}
              {step === 8 && (
                <div className="cg-step">
                  <div className="cg-card">
                    <div className="cg-clash" style={{ fontSize: 17, letterSpacing: 2, color: S.accent, marginBottom: 4 }}>08 — Preview, Translate & Import to Funnel</div>
                    <div style={{ fontSize: 12, color: S.muted, marginBottom: 16 }}>Translation via Claude. Select language → translate → choose product → import.</div>

                    {/* Language selector */}
                    <div style={{ marginBottom: 16 }}>
                      <label className="cg-lbl">Select Language</label>
                      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        {['English', ...LANGUAGES.filter(l => l !== 'English')].map(lang => (
                          <div key={lang} className={`cg-lang-chip ${previewLang === lang ? 'sel' : ''}`} onClick={() => translateContent(lang)}>
                            {translated[lang] && <span style={{ fontSize: 9, color: S.accent3 }}>✓</span>}
                            {lang}
                          </div>
                        ))}
                      </div>
                      {translating && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
                          <div className="cg-spinner" style={{ width: 16, height: 16, borderWidth: 2 }} />
                          <span style={{ fontSize: 11, color: S.muted }}>Translating to {translatingTo}... (3 parallel Claude calls)</span>
                        </div>
                      )}
                    </div>

                    {/* Import section */}
                    <div style={{ background: S.surface2, border: `1px solid ${S.border}`, borderRadius: 10, padding: 14, marginBottom: 16 }}>
                      <label className="cg-lbl" style={{ marginBottom: 8 }}>Import <span style={{ color: S.accent2 }}>{previewLang}</span> content to Funnel Building</label>

                      <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                        <div style={{display:'flex',gap:8,flexWrap:'wrap',flex:1}}>
                          <select className="cg-inp" style={{flex:1,minWidth:160}} value={selectedFunnelProduct||''} onChange={e=>{setSelectedFunnelProduct(e.target.value);loadFunnelMarkets(e.target.value)}}>
                            <option value="">Select Product...</option>
                            {funnelProducts.map(p=><option key={p.product_id} value={p.product_id}>{p.product_id} — {p.product_name?.substring(0,35)}</option>)}
                          </select>
                          {funnelMarkets.length>0&&(
                            <select className="cg-inp" style={{flex:1,minWidth:100}} value={selectedFunnelMarket} onChange={e=>setSelectedFunnelMarket(e.target.value)}>
                              {funnelMarkets.map(m=><option key={m} value={m}>{m}</option>)}
                            </select>
                          )}
                        </div>
                        <button className="cg-btn success sm" onClick={importToFunnel} disabled={importingFunnel||!selectedFunnelProduct||!selectedFunnelMarket}>
                          {importingFunnel?'Importing...':funnelImported[`${selectedFunnelProduct}_${selectedFunnelMarket}_${previewLang}`]?'✓ Imported':'→ Import'}
                        </button>
                      </div>
                      {Object.keys(funnelImported).length > 0 && (
                        <div style={{ marginTop: 8, fontSize: 11, color: S.accent3 }}>Imported: {Object.keys(funnelImported).map(k => k.split('_').join(' → ')).join(', ')}</div>
                      )}
                    </div>

                    {/* Content preview */}
                    {preview && (
                      <div>
                        <div style={{ marginBottom: 12 }}><div className="cg-out-lbl">Brand</div><div className="cg-out-txt">{preview.brand}</div></div>
                        <div style={{ marginBottom: 12 }}><div className="cg-out-lbl">Title</div><div className="cg-out-txt">{preview.title}</div></div>
                        {preview.benefits?.length > 0 && <div style={{ marginBottom: 12 }}><div className="cg-out-lbl">Benefits</div><div className="cg-out-txt">{Array.isArray(preview.benefits) ? preview.benefits.join('\n') : preview.benefits}</div></div>}
                        {preview.paragraphs?.length > 0 && (
                          <div style={{ marginBottom: 12 }}>
                            <div className="cg-out-lbl">Paragraphs</div>
                            {preview.paragraphs.map((p, i) => (
                              <div key={i} className="cg-para" style={{ borderColor: S.accent2, paddingRight: 14 }}>
                                <div style={{ fontWeight: 700, fontSize: 12, marginBottom: 3 }}>{p.headline}</div>
                                <div style={{ fontSize: 11, color: S.muted, lineHeight: 1.7 }}>{p.body}</div>
                              </div>
                            ))}
                          </div>
                        )}
                        {preview.reviews?.length > 0 && (
                          <div style={{ marginBottom: 12 }}>
                            <div className="cg-out-lbl">Reviews ({preview.reviews.length})</div>
                            {preview.reviews.map((r, i) => (
                              <div key={i} className="cg-review" style={{ paddingRight: 14 }}>
                                <div style={{ fontWeight: 600, fontSize: 12 }}>{r.name}</div>
                                <div style={{ color: S.gold, fontSize: 11 }}>★★★★★</div>
                                <div style={{ fontSize: 11, color: S.muted, lineHeight: 1.6, marginTop: 3 }}>{r.review}</div>
                              </div>
                            ))}
                          </div>
                        )}
                        {preview.faqs?.length > 0 && (
                          <div style={{ marginBottom: 12 }}>
                            <div className="cg-out-lbl">FAQs</div>
                            {preview.faqs.map((f, i) => (
                              <div key={i} style={{ marginBottom: 8 }}>
                                <div className="cg-faq-q">Q{i + 1}: {f.question}</div>
                                <div className="cg-faq-a">A: {f.answer}</div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <button className="cg-btn primary" onClick={() => unlock(9)}>Next: Ad Copy →</button>
                  </div>
                </div>
              )}

              {/* STEP 9 — Ad Copy */}
              {step === 9 && (
                <div className="cg-step">
                  <div className="cg-card">
                    <div className="cg-clash" style={{ fontSize: 17, letterSpacing: 2, color: S.accent, marginBottom: 4 }}>09 — Facebook Ad Copy</div>
                    <div style={{ fontSize: 12, color: S.muted, marginBottom: 16 }}>
                      <span style={{ color: S.accent2 }}>Ad copy via Claude</span> · <span style={{ color: S.accent2 }}>Translation via Claude</span>
                    </div>

                    {adVersionsEN.length === 0 && !loading && (
                      <div>
                        <div className="cg-row">
                          <div><label className="cg-lbl">Campaign Objective</label>
                            <select className="cg-inp" value={adObjective} onChange={e => setAdObjective(e.target.value)}>
                              <option value="conversions">💰 Conversions</option>
                              <option value="traffic">🌐 Traffic</option>
                              <option value="awareness">📣 Awareness</option>
                            </select>
                          </div>
                          <div><label className="cg-lbl">Tone</label>
                            <select className="cg-inp" value={adTone} onChange={e => setAdTone(e.target.value)}>
                              <option value="urgent">Urgent & Direct</option>
                              <option value="friendly">Friendly & Conversational</option>
                              <option value="luxury">Premium & Aspirational</option>
                              <option value="emotional">Emotional & Story-driven</option>
                            </select>
                          </div>
                        </div>
                        <div style={{ marginBottom: 14 }}><label className="cg-lbl">CTA</label>
                          <select className="cg-inp" value={adCta} onChange={e => setAdCta(e.target.value)}>
                            {['Shop Now', 'Learn More', 'Get Offer', 'Order Now', 'Try Now', 'Get Started'].map(o => <option key={o}>{o}</option>)}
                          </select>
                        </div>
                        <div style={{ textAlign: 'center' }}>
                          <button className="cg-btn primary" onClick={generateAdCopy} style={{ padding: '11px 28px', fontSize: 14 }}>⚡ Generate 3 Ad Versions via Claude</button>
                        </div>
                      </div>
                    )}

                    {loading && renderLoading()}

                    {adVersionsEN.length > 0 && (
                      <div>
                        {/* Language selector */}
                        <div style={{ marginBottom: 12 }}>
                          <label className="cg-lbl">Translate Ad Copy (via Claude)</label>
                          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                            {['English', ...LANGUAGES.filter(l => l !== 'English')].map(lang => (
                              <div key={lang} className={`cg-lang-chip ${adLang === lang ? 'sel' : ''}`} onClick={() => translateAds(lang)}>
                                {translatedAds[lang] && <span style={{ fontSize: 9, color: S.accent3 }}>✓</span>}
                                {lang}
                              </div>
                            ))}
                          </div>
                          {translatingAds && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
                              <div className="cg-spinner" style={{ width: 16, height: 16, borderWidth: 2 }} />
                              <span style={{ fontSize: 11, color: S.muted }}>Translating to {translatingAdsTo}...</span>
                            </div>
                          )}
                        </div>

                        {/* Version selector */}
                        {currentAds.length > 0 && (
                          <div style={{ display: 'flex', gap: 6, marginBottom: 12, flexWrap: 'wrap' }}>
                            <span style={{ fontSize: 11, color: S.muted, alignSelf: 'center' }}>Select version to import:</span>
                            {currentAds.map((v, i) => (
                              <div key={i} onClick={() => setSelectedAdVersion(i)} style={{ padding: '5px 12px', borderRadius: 8, cursor: 'pointer', fontSize: 11, fontWeight: 600, border: `1px solid ${selectedAdVersion === i ? S.accent : S.border}`, background: selectedAdVersion === i ? 'rgba(124,92,252,.15)' : S.surface2, color: selectedAdVersion === i ? '#a080ff' : S.muted }}>
                                {v.isWinner ? '★ ' : ''}Version {v.version} (Score {v.score})
                              </div>
                            ))}
                          </div>
                        )}

                        {/* Import */}
                        <div style={{ background: S.surface2, border: `1px solid ${S.border}`, borderRadius: 10, padding: 14, marginBottom: 16 }}>
                          <label className="cg-lbl" style={{ marginBottom: 8 }}>Import <span style={{ color: S.accent2 }}>{adLang}</span> — Version {currentAds[selectedAdVersion]?.version} to Ad Copy</label>
                          <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                            <div style={{display:'flex',gap:8,flexWrap:'wrap',flex:1}}>
                              <select className="cg-inp" style={{flex:1,minWidth:160}} value={selectedAdProduct||''} onChange={e=>{setSelectedAdProduct(e.target.value);loadAdMarkets(e.target.value)}}>
                                <option value="">Select Product...</option>
                                {adProducts.map(p=><option key={p.product_id} value={p.product_id}>{p.product_id} — {p.product_name?.substring(0,35)}</option>)}
                              </select>
                              {adMarkets.length>0&&(
                                <select className="cg-inp" style={{flex:1,minWidth:100}} value={selectedAdMarket} onChange={e=>setSelectedAdMarket(e.target.value)}>
                                  <option value="">Select Market...</option>
                                  {adMarkets.map(m=><option key={m} value={m}>{m}</option>)}
                                </select>
                              )}
                            </div>
                            <button className="cg-btn success sm" onClick={importAdCopy} disabled={importingAd||!selectedAdProduct||!selectedAdMarket}>
                              {importingAd?'Importing...':adImported[`${selectedAdProduct}_${selectedAdMarket}_${adLang}`]?'✓ Imported':'→ Import'}
                            </button>
                          </div>
                          {Object.keys(adImported).length > 0 && (
                            <div style={{ marginTop: 8, fontSize: 11, color: S.accent3 }}>Imported: {Object.keys(adImported).map(k => k.split('_').join(' → ')).join(', ')}</div>
                          )}
                        </div>

                        {/* Ad versions */}
                        {currentAds.map((v, i) => (
                          <div key={i} onClick={() => setSelectedAdVersion(i)} style={{ background: S.surface2, border: `2px solid ${selectedAdVersion === i ? S.accent : v.isWinner ? S.gold : S.border}`, borderRadius: 12, marginBottom: 14, overflow: 'hidden', cursor: 'pointer', transition: 'border-color .15s' }}>
                            {v.isWinner && <div style={{ background: `linear-gradient(90deg,${S.gold},#ff9f43)`, color: '#000', textAlign: 'center', fontSize: 9, fontWeight: 700, fontFamily: 'monospace', padding: '3px', letterSpacing: 1 }}>★ BEST VERSION — Score {v.score}</div>}
                            <div style={{ padding: 14 }}>
                              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
                                <span className="cg-mono" style={{ fontSize: 10, color: S.muted }}>Version {v.version} — {v.approach}</span>
                                <span className="cg-mono" style={{ fontSize: 16, fontWeight: 700, color: v.isWinner ? S.gold : S.text }}>{v.score}</span>
                              </div>
                              {/* FB mockup */}
                              <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden', marginBottom: 10, border: '1px solid #e4e6eb', fontFamily: '-apple-system,sans-serif' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '10px 12px 6px' }}>
                                  <div style={{ width: 32, height: 32, borderRadius: '50%', background: `linear-gradient(135deg,${S.accent},${S.accent2})`, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 700, fontSize: 12 }}>A</div>
                                  <div><div style={{ fontWeight: 700, fontSize: 12, color: '#050505' }}>{selectedBrand}</div><div style={{ fontSize: 10, color: '#65676b' }}>Sponsored</div></div>
                                </div>
                                <div style={{ padding: '0 12px 8px', fontSize: 12, color: '#050505', lineHeight: 1.5, maxHeight: 70, overflow: 'hidden' }}>{v.primaryText}</div>
                                <div style={{ width: '100%', aspectRatio: '1.91/1', background: 'linear-gradient(135deg,#1a1a2e,#0f3460)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                  <span style={{ fontSize: 9, color: 'rgba(255,255,255,.3)', fontFamily: 'monospace', textTransform: 'uppercase', letterSpacing: 1 }}>Ad Creative</span>
                                </div>
                                <div style={{ borderTop: '1px solid #e4e6eb', padding: '7px 12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                  <div style={{ fontWeight: 700, fontSize: 13, color: '#050505' }}>{v.headline}</div>
                                  <div style={{ background: '#e4e6eb', borderRadius: 5, padding: '5px 10px', fontSize: 11, fontWeight: 600 }}>{adCta}</div>
                                </div>
                              </div>
                              <div style={{ marginBottom: 6 }}><div className="cg-out-lbl">Primary Text</div><div className="cg-out-txt" style={{ fontSize: 11 }}>{v.primaryText}</div></div>
                              <div style={{ fontSize: 11, color: S.muted, fontStyle: 'italic' }}>{v.whyItWorks}</div>
                            </div>
                          </div>
                        ))}
                        <button className="cg-btn outline sm" onClick={() => { setAdVersionsEN([]); setTranslatedAds({}); setAdLang('English') }}>↺ Regenerate Ad Copy</button>
                      </div>
                    )}
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 8 }}>
                    <button className="cg-btn success" onClick={() => unlock(10)}>✓ Finish →</button>
                  </div>
                </div>
              )}

              {/* STEP 10 — Finish */}
              {step === 10 && (
                <div className="cg-step">
                  <div className="cg-card" style={{ textAlign: 'center', padding: 40 }}>
                    <div style={{ fontSize: 48, marginBottom: 16 }}>✓</div>
                    <div className="cg-clash" style={{ fontSize: 20, color: S.accent3, marginBottom: 8 }}>All Done!</div>
                    <div style={{ fontSize: 13, color: S.muted, marginBottom: 24 }}>Content generated and imported successfully.</div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 24, textAlign: 'left' }}>
                      {[['Brand', selectedBrand], ['Title', selectedTitle?.substring(0, 50)], ['Funnel Imports', Object.keys(funnelImported).length + ' done'], ['Ad Copy Imports', Object.keys(adImported).length + ' done']].map(([l, v]) => (
                        <div key={l} style={{ background: S.surface2, borderRadius: 8, padding: '10px 12px', border: `1px solid ${S.border}` }}>
                          <div className="cg-mono" style={{ fontSize: 9, color: S.muted, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 3 }}>{l}</div>
                          <div style={{ fontSize: 12, fontWeight: 600, color: S.text }}>{v || '—'}</div>
                        </div>
                      ))}
                    </div>
                    <button className="cg-btn outline" onClick={onClose}>Close Generator</button>
                  </div>
                </div>
              )}
            </div>

            {/* Backend Instructions Panel */}
            <div className={`cg-instr-panel ${instrOpen ? 'open' : ''}`}>
              <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', padding: '20px 20px 16px', borderBottom: `1px solid ${S.border}`, flexShrink: 0 }}>
                <div>
                  <div className="cg-clash" style={{ fontSize: 15, fontWeight: 700, color: '#fff', marginBottom: 3 }}>Backend Instructions</div>
                  <div style={{ fontSize: 11, color: S.muted }}>GPT-4o for content · Claude for translation & ad copy</div>
                </div>
                <button onClick={() => setInstrOpen(false)} style={{ background: S.surface2, border: `1px solid ${S.border}`, color: S.muted, borderRadius: 8, width: 30, height: 30, cursor: 'pointer', fontSize: 14, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>✕</button>
              </div>
              <div className="cg-instr-body">
                <div className="cg-section-lbl">⚡ ChatGPT (GPT-4o) Instructions</div>
                {[['brand', 'Brand Naming'], ['title', 'Product Title'], ['benefits', 'Benefits Writing'], ['paragraph', 'Paragraph / Description'], ['reviews', 'Reviews'], ['faqs', 'FAQs']].map(([key, label]) => (
                  <div key={key} className="cg-instr-field">
                    <label>{label}</label>
                    <textarea value={instr[key]} onChange={e => updateInstr(key, e.target.value)} rows={3} />
                  </div>
                ))}
                <div className="cg-section-lbl">✦ Claude Instructions</div>
                {[['translate', 'Translation'], ['adcopy', 'Ad Copy']].map(([key, label]) => (
                  <div key={key} className="cg-instr-field">
                    <label>{label}</label>
                    <textarea value={instr[key]} onChange={e => updateInstr(key, e.target.value)} rows={key === 'adcopy' ? 6 : 3} />
                  </div>
                ))}
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 12 }}>
                  <button className="cg-btn primary" onClick={saveInstrToDB} disabled={instrSaving} style={{ width: '100%', justifyContent: 'center' }}>
                    {instrSaving ? 'Saving...' : instrSaved ? '✓ Saved!' : '💾 Save Instructions'}
                  </button>
                  <button className="cg-btn outline sm" onClick={() => { setInstr(DEFAULT_INSTR); setInstrSaved(false) }} style={{ width: '100%', justifyContent: 'center' }}>Reset to Defaults</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
